import styles from './style.module.css';

import logoWhatsApp from '../../../../assets/images/whatsapp-light.png';
import logoClose from '../../../../assets/images/close.png';
import profile from '../../../../assets/images/profile-whatsapp.png';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { IHost } from '../../interfaces';

interface IWhatsAppCapture {
  data?: any;
  isOpen?: boolean;
  client: any;
  player: any;
  host: IHost;
}

export function WhatsAppCapture({
  data,
  isOpen,
  client,
  player,
  host,
}: IWhatsAppCapture) {
  const [isOpenBox, setIsOpenBox] = useState(false);
  const [isEnabledStep1, setIsEnabledStep1] = useState(false);
  const [isEnabledStep2, setIsEnabledStep2] = useState(false);
  const [isEnabledStep3, setIsEnabledStep3] = useState(false);
  const [hasClass, setHasClass] = useState(true);
  const [notTrigger, setNotTrigger] = useState(false);
  const [whatsAppImage, setWhatsAppImage] = useState<string>('');
  const [whatsAppName, setWhatsAppName] = useState<string>('');
  const [responseStep1, setResponseStep1] = useState();
  const [responseStep2, setResponseStep2] = useState();
  const [responseStep3, setResponseStep3] = useState();

  const input1: any = useRef();
  const input2: any = useRef();
  const input3: any = useRef();

  useEffect(() => {
    setIsEnabledStep1(true);
    startScrolling();

    localStorage.removeItem('isCapturedLeadWhatsApp');

    if (client?.programType === 'OQ Incentivar') {
      setWhatsAppName(player.name);
      setWhatsAppImage(
        player.photoURL || client?.whatsappCustomIconPersona || profile
      );
    } else if (Object.keys(host).length !== 0) {
      setWhatsAppName(host.name);
      setWhatsAppImage(host.photoURL);
    } else {
      setWhatsAppName(
        client?.whatsappBotName ? client?.whatsappBotName : 'Pâmela Soares'
      );
      setWhatsAppImage(
        client?.whatsappCustomIconPersona
          ? client?.whatsappCustomIconPersona
          : profile
      );
    }

    window.addEventListener('scroll', () => {
      const element = document.getElementById('form-conversion');
      const rect = element ? element.getBoundingClientRect() : null;
      const isCapturedLeadWhatsApp = localStorage.getItem(
        'isCapturedLeadWhatsApp'
      );
      if (rect && !isCapturedLeadWhatsApp) {
        if (rect?.top <= -250) {
          setIsOpenBox(true);
          setNotTrigger(true);
        }
      }
    });

    const intervalId = setInterval(() => {
      if (!isOpenBox) {
        setHasClass((prevHasClass) => !prevHasClass);
      }
    }, 12000);

    return () => clearInterval(intervalId);
  }, [client]);

  useEffect(() => {
    setIsOpenBox(isOpen);
  }, [isOpen]);

  function isValidEmail(email: string): boolean {
    // Expressão regular para validar o formato do e-mail
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const maskTel = (value: string): string => {
    value = value.replace(/\D/g, '');
    value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
    value = value.replace(/(\d)(\d{4})$/, '$1-$2');
    return value;
  };

  function resetData() {
    setIsEnabledStep1(false);
    setIsEnabledStep2(false);
    setIsEnabledStep3(false);
    setResponseStep1(null);
    setResponseStep2(null);
    setResponseStep3(null);
  }

  function startScrolling() {
    setInterval(() => {
      const element: any = document.getElementById('content-chat');
      if (element) {
        element.scrollTop = element.scrollHeight;
      }
    }, 100);
  }

  return (
    <>
      {isOpenBox && (
        <div className="animate__animated animate__fadeIn">
          <div className={`position-fixed shadow ${styles.box}`}>
            <div className="p-3">
              <div className="d-flex">
                <img
                  src={whatsAppImage}
                  width={45}
                  height={45}
                  className="rounded-circle me-2"
                  alt=""
                />
                <div>
                  <span className="fs-5 text-white">{whatsAppName}</span>
                  <br />
                  <span className="tiny-text text-white">Disponível agora</span>
                  <br />
                </div>
              </div>
            </div>
            <div className="p-1">
              <div
                className={`rounded-3 p-2 ${styles.bgWhats} ${styles.content}`}
                style={{ height: '390px' }}
                id="content-chat"
              >
                <div className="row">
                  {isEnabledStep1 && (
                    <>
                      {/* primeira ação */}
                      <div className="col-12">
                        <span
                          className={`${styles.bubble} float-start bg-white p-2 rounded-3 text-break animate__animated animate__fadeIn animate__delay-1s`}
                        >
                          {client?.programType === 'OQ Incentivar'
                            ? `Olá! Meu nome é ${whatsAppName}. Ficamos felizes por seu interesse!.`
                            : `Olá! Meu nome é ${whatsAppName}. Ficamos felizes por ${player?.name} ter te indicado.`}
                        </span>
                      </div>

                      <div className="col-12">
                        <div className="mt-2">
                          <span
                            className={`${styles.bubble} float-start bg-white p-2 rounded-3 text-break animate__animated animate__fadeIn animate__delay-2s`}
                          >
                            Antes de continuarmos, por favor, digite seu nome e
                            sobrenome:
                          </span>
                        </div>
                      </div>
                      {/* primeira ação */}

                      {/* Resposta 1 */}
                      <div className="col-12">
                        <span
                          className={`${styles.bubble} float-end bg-whats-color p-2 rounded-3 text-break my-3 mx-1 animate__animated animate__fadeIn animate__delay-3s`}
                        >
                          <div className="d-flex">
                            <input
                              type="text"
                              disabled={isEnabledStep2}
                              ref={input1}
                              className="w-100"
                              value={responseStep1}
                              onKeyDown={(e: any) => {
                                if (e.key === 'Enter') {
                                  if (input1.current.value === '') {
                                    toast.info('Informe seu nome e sobrenome!');
                                  } else {
                                    setResponseStep1(input1.current.value);
                                    setIsEnabledStep2(true);
                                  }
                                }
                              }}
                            />
                            {!isEnabledStep2 && (
                              <button
                                className="btn rounded-circle bg-primary ms-2"
                                style={{ aspectRatio: '1/1' }}
                                onClick={() => {
                                  if (input1.current.value === '') {
                                    toast.info('Informe seu nome e sobrenome!');
                                  } else {
                                    setResponseStep1(input1.current.value);
                                    setIsEnabledStep2(true);
                                  }
                                }}
                              >
                                <i className="material-icons tiny-text text-white">
                                  send
                                </i>
                              </button>
                            )}
                          </div>
                        </span>
                      </div>
                      {/* Resposta 1 */}
                    </>
                  )}

                  {isEnabledStep2 && (
                    <>
                      {/* terceira ação */}
                      <div className="col-12">
                        <span
                          className={`${styles.bubble} float-start bg-white p-2 rounded-3 text-break animate__animated animate__fadeIn animate__delay-1s`}
                        >
                          Muito bom! Por favor, me diga seu email...
                        </span>
                      </div>
                      {/* terceira ação */}

                      {/* Resposta 2 */}
                      <div className="col-12">
                        <span
                          className={`${styles.bubble} float-end bg-whats-color p-2 rounded-3 text-break my-3 mx-1 animate__animated animate__fadeIn animate__delay-2s`}
                        >
                          <div className="d-flex">
                            <input
                              type="text"
                              disabled={isEnabledStep3}
                              ref={input2}
                              className="w-100"
                              value={responseStep2}
                              onKeyDown={(e: any) => {
                                if (e.key === 'Enter') {
                                  if (!isValidEmail(input2.current.value)) {
                                    toast.info('Informe um email válido!');
                                  } else {
                                    setResponseStep2(input2.current.value);
                                    setIsEnabledStep3(true);
                                  }
                                }
                              }}
                            />
                            {!isEnabledStep3 && (
                              <button
                                className="btn rounded-circle bg-primary ms-2"
                                style={{ aspectRatio: '1/1' }}
                                onClick={() => {
                                  if (!isValidEmail(input2.current.value)) {
                                    toast.info('Informe um email válido!');
                                  } else {
                                    setResponseStep2(input2.current.value);
                                    setIsEnabledStep3(true);
                                  }
                                }}
                              >
                                <i className="material-icons tiny-text text-white">
                                  send
                                </i>
                              </button>
                            )}
                          </div>
                        </span>
                      </div>
                      {/* Resposta 2 */}
                    </>
                  )}

                  {isEnabledStep3 && (
                    <>
                      {/* quarta ação */}
                      <div className="col-12">
                        <span
                          className={`${styles.bubble} float-start bg-white p-2 rounded-3 text-break animate__animated animate__fadeIn animate__delay-1s`}
                        >
                          Agora, para você receber um atendimento todo especial,
                          digite seu WhatsApp, com DDD, por favor.
                        </span>
                      </div>
                      {/* quarta ação */}

                      {/* Resposta 3 */}
                      <div className="col-12">
                        <span
                          className={`${styles.bubble} float-end bg-whats-color p-2 rounded-3 text-break my-3 mx-1 animate__animated animate__fadeIn animate__delay-2s`}
                        >
                          <div className="d-flex">
                            <input
                              type="text"
                              ref={input3}
                              disabled={responseStep3}
                              value={responseStep3}
                              onChange={(event) => {
                                const { value } = event.target;
                                event.target.value = maskTel(value);
                              }}
                              onKeyDown={(e: any) => {
                                if (e.key === 'Enter') {
                                  if (input3.current.value.length < 15) {
                                    toast.info('Informe um telefone válido!');
                                  } else {
                                    setResponseStep3(input3.current.value);
                                    setIsEnabledStep3(true);
                                    if (typeof data === 'function') {
                                      data({
                                        name: responseStep1,
                                        email: responseStep2,
                                        phone: input3.current.value,
                                      });
                                      localStorage.setItem(
                                        'isCapturedLeadWhatsApp',
                                        'true'
                                      );
                                    }
                                    setTimeout(() => {
                                      resetData();
                                      setIsOpenBox(false);
                                      setIsEnabledStep1(true);
                                    }, 8000);
                                  }
                                }
                              }}
                              minLength={15}
                              maxLength={15}
                              className="w-100"
                            />
                            {!responseStep3 && (
                              <button
                                className="btn rounded-circle bg-primary ms-2"
                                style={{ aspectRatio: '1/1' }}
                                onClick={() => {
                                  if (input3.current.value.length < 15) {
                                    toast.info('Informe um telefone válido!');
                                  } else {
                                    setResponseStep3(input3.current.value);
                                    setIsEnabledStep3(true);
                                    if (typeof data === 'function') {
                                      data({
                                        name: responseStep1,
                                        email: responseStep2,
                                        phone: input3.current.value,
                                      });
                                      localStorage.setItem(
                                        'isCapturedLeadWhatsApp',
                                        'true'
                                      );
                                    }
                                    setTimeout(() => {
                                      resetData();
                                      setIsOpenBox(false);
                                      setIsEnabledStep1(true);
                                    }, 8000);
                                  }
                                }}
                              >
                                <i className="material-icons tiny-text text-white">
                                  send
                                </i>
                              </button>
                            )}
                          </div>
                        </span>
                      </div>
                      {/* Resposta 3 */}
                    </>
                  )}
                  {responseStep3 && (
                    <>
                      {/* finalização */}
                      <div className="col-12">
                        <span
                          className={`${styles.bubble} float-start bg-white p-2 rounded-3 text-break animate__animated animate__fadeIn animate__delay-1s`}
                        >
                          {Object.keys(host).length !== 0
                            ? `Muito obrigado, ${responseStep1}. Entrarei em contato direto com você o mais rápido possível.`
                            : `Muito obrigada pelo interesse! Entraremos em contato o mais rápido possível...até já!`}
                        </span>
                      </div>
                      {/* finalização */}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className={`position-fixed animate__animated ${styles.positionButton} ${!isOpenBox && hasClass ? '' : 'animate__shakeX'}`}
      >
        <button
          className={`btn ${styles.button} shadow`}
          onClick={() => {
            setIsOpenBox(!isOpenBox);
            if (notTrigger) {
              localStorage.setItem('isCapturedLeadWhatsApp', 'true');
            }
          }}
        >
          {isOpenBox ? (
            <img src={logoClose} width={30} height={30} alt="" />
          ) : (
            <img src={logoWhatsApp} width={30} height={30} alt="" />
          )}
        </button>
      </div>
    </>
  );
}
